module.exports = __webpack_public_path__ + "static/FirebaseCreate-d1210f49713090ca84cf9583cfeb463b.png";